export default __webpack_public_path__ + "static/media/image.ce77f3c3.jpeg";